import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "animated-logo" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      class: "icon",
      style: _normalizeStyle({position: 'absolute',opacity: $props.animate ? 1 : 0}),
      icon: "animated/logo-line-v2-90f",
      width: "1.4rem",
      height: "1.4rem",
      external: ""
    }, null, 8 /* PROPS */, ["style"]),
    _createVNode(_component_Icon, {
      class: "icon",
      style: _normalizeStyle({position: 'absolute',opacity: $props.animate ? 0 : 1}),
      stroke: $props.stroke,
      icon: "g-logo",
      width: "1.6rem",
      height: "1.6rem"
    }, null, 8 /* PROPS */, ["style", "stroke"])
  ]))
}